import { ErrorHandler, NgModule } from '@angular/core';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { TelemetryService } from './telemetryservice';
 
@NgModule({
  providers: [
    TelemetryService,
    {
        provide: ErrorHandler,
        useClass: ApplicationinsightsAngularpluginErrorService,
    }],
})
export class TelemetryModule {
}